import { Capacitor, registerPlugin } from '@capacitor/core';

const applePlugin = registerPlugin('MyPiggyAppleSignIn');

export const isNativeAppleSignInAvailable = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';

const bytesToHex = (bytes) =>
  Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');

export const getAppleIdentity = async () => {
  if (!isNativeAppleSignInAvailable()) {
    throw new Error('Apple sign-in is available only in the iOS app.');
  }

  if (!globalThis.crypto?.getRandomValues || !globalThis.crypto?.subtle) {
    throw new Error('Secure device cryptography is unavailable.');
  }

  const nonceBytes = new Uint8Array(32);
  crypto.getRandomValues(nonceBytes);
  const rawNonce = bytesToHex(nonceBytes);
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(rawNonce)
  );
  const hashedNonce = bytesToHex(new Uint8Array(digest));

  const credential = await applePlugin.signIn({ hashedNonce });
  if (!credential?.identityToken) {
    throw new Error('Apple did not return an identity token.');
  }

  return { ...credential, rawNonce };
};
